import React from "react";

/**
 * Invoice history empty state. Copy names the Basic plan as per the design.
 */
const EmptyInvoices = ({ planName = "Basic", onViewPlan }) => {
  const hasPlan = Boolean(planName);

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center rounded-3 px-4 py-5"
      style={{
        border: "1px dashed #D0D5DD",
        background: "#FCFCFD",
        minHeight: 320,
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center mb-3"
        style={{
          width: 56,
          height: 56,
          borderRadius: 14,
          background: "#F4EBFF",
          color: "#7F56D9",
          fontSize: "1.6rem",
          fontWeight: 700,
        }}
      >
        $
      </div>

      <p className="fw-bold mb-2" style={{ color: "#101828", fontSize: "1.15rem" }}>
        No invoices yet
      </p>

      <p
        className="text-muted mb-4"
        style={{ maxWidth: 520, fontSize: "0.95rem" }}
      >
        {hasPlan
          ? `You haven't been billed. Once your ${planName} subscription starts, every monthly receipt shows up here as a downloadable PDF.`
          : "You haven't been billed. Once your subscription starts, every monthly receipt shows up here as a downloadable PDF."}
      </p>

      <button
        type="button"
        className="btn px-4 py-2 rounded-3 fw-semibold"
        style={{ background: "#7F56D9", color: "#FFFFFF", border: "none" }}
        onClick={onViewPlan}
      >
        {hasPlan ? `View the ${planName} plan` : "View plans"}
      </button>
    </div>
  );
};

export default EmptyInvoices;
